export default __webpack_public_path__ + "static/media/suite-montanha2-3.236f410d.webp";